import React from "react";
import { formatPrice, formattedDateTime } from "../../Helpers/BaseHelper";
const PaymentInfo = ({ paymentInfo, formatDate, discount }) => {
  return (
    <div>
      <h6 className="mb-2">Thông tin thanh toán</h6>
      <div className="row g-3">
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Id thanh toán</h6>
          <p className="fs-16 text-primary">#{paymentInfo.bookingId}</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Phương thức thanh toán</h6>
          <p className="fs-16 text-gray-6">{paymentInfo.paymentMethod}</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Trạng thái thanh toán</h6>
          <p className="fs-16 text-success">{paymentInfo.status}</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Ngày thanh toán</h6>
          <p className="fs-16 text-gray-6">
            {formattedDateTime(paymentInfo.paymentDate)}
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Thuế</h6>
          <p className="fs-16 text-gray-6">0% ({formatPrice(0)})</p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Giảm giá</h6>
          <p className="fs-16 text-gray-6">
            {discount
              ? `${discount.discountPercentage}% (${formatPrice(
                  (paymentInfo.amount / (1 - discount.discountPercentage)) * -1
                )})`
              : `0% (${formatPrice(0)})`}{" "}
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Phí đặt chỗ</h6>
          {/* <p className="fs-16 text-gray-6">{formatPrice(paymentInfo.amount)}</p> */}
          <p className="fs-16 text-gray-6">
            {discount
              ? formatPrice(
                  paymentInfo.amount / (1 - discount.discountPercentage / 100)
                )
              : formatPrice(paymentInfo.amount)}
          </p>
        </div>
        <div className="col-lg-3">
          <h6 className="fs-14 mb-1">Tổng số tiền đã thanh toán</h6>
          <p className="fs-16 text-gray-6">{formatPrice(paymentInfo.amount)}</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
